import {
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_0,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance3lu3946d91kk8 as Companion_getInstance_1,
  RectCorners2yrtl8r42p5bs as RectCorners,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance1wjuqlbt5kx1j as Companion_getInstance_2,
  Korge3fi4cwjkh8up9 as Korge,
  Stage1ggtrzujnnkl0 as Stage,
  Container7486fjmip554 as Container,
  addTo25e29vq105prw as addTo,
  Sprite19oods84ct31j as Sprite,
  positionu6441b7hkb4l as position,
  SpriteAnimationagta0d6ji85w as SpriteAnimation,
  Lineazu98ookfk8s as Line,
  addUpdater1la23qj9g2d42 as addUpdater,
  SolidRect131p7hyzlx7j8 as SolidRect,
  get_keysmipauarvwdlb as get_keys,
  RoundRect16qm0yoxjizxs as RoundRect,
  get_mouse1jstwhfaumelj as get_mouse,
  Companion_instance1qzytx5vkv693 as Companion_instance,
  Text3kimhvgfxflj3 as Text,
} from './korge-root-korge.mjs';
import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  coerceIn1xblvmyr0tby6 as coerceIn,
  coerceAtLeastklytehohcpeq as coerceAtLeast,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  padStart36w1507hs626a as padStart,
  Companion_getInstance148flmv2wtrla as Companion_getInstance_3,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  listOf1jh22dvmctj1r as listOf,
  until1jbpn0z3f8lbg as until,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  roundToInt1ue8x8yshtznx as roundToInt,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  Random2w0u2xak2xaqi as Random,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  isFinite2t9l5a275mxm6 as isFinite,
  Companion_instance144r68bk89en4 as Companion_instance_0,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  removeAll3o43e67jmwdpc as removeAll,
  compareTo3ankvs086tmwq as compareTo,
  Enum3alwj03lh1n41 as Enum,
  numberToDouble210hrknaofnhf as numberToDouble,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import { get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs } from './korlibs-io-root-korlibs-io.mjs';
import {
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  _RGBA___get_a__impl__6msvu7bgji1ly0wy68 as _RGBA___get_a__impl__6msvu7,
  RGBA__withA_impl_vogscmo6m2y7jfvd66 as RGBA__withA_impl_vogscm,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_4,
  RGBA34obx2i62wcl3 as RGBA,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_5,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
} from './korlibs-image-root-korlibs-image.mjs';
import { readMusic27z8rq3uu0hc8 as readMusic } from './korlibs-audio-root-korlibs-audio.mjs';
import { get_secondsjblpw5qd4dzj as get_seconds } from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Key_SPACE_getInstance3ccpin6uc1wp0 as Key_SPACE_getInstance,
  Key_UP_getInstance3m44cx75e2bd1 as Key_UP_getInstance,
  Key_RIGHT_getInstance3209gaexis4i6 as Key_RIGHT_getInstance,
} from './korge-root-korge-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class main$slambda {
  a9m($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Korge), $completion);
  }
  wd(p1, $completion) {
    return this.a9m(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class BallFlight {
  constructor(fromX, fromY, targetX, targetY, progress) {
    this.bc3_1 = fromX;
    this.cc3_1 = fromY;
    this.dc3_1 = targetX;
    this.ec3_1 = targetY;
    this.fc3_1 = progress;
  }
  gc3(fromX, fromY, targetX, targetY, progress) {
    return new BallFlight(fromX, fromY, targetX, targetY, progress);
  }
  hc3(fromX, fromY, targetX, targetY, progress, $super) {
    fromX = fromX === VOID ? this.bc3_1 : fromX;
    fromY = fromY === VOID ? this.cc3_1 : fromY;
    targetX = targetX === VOID ? this.dc3_1 : targetX;
    targetY = targetY === VOID ? this.ec3_1 : targetY;
    progress = progress === VOID ? this.fc3_1 : progress;
    return $super === VOID ? this.gc3(fromX, fromY, targetX, targetY, progress) : $super.gc3.call(this, fromX, fromY, targetX, targetY, progress);
  }
  toString() {
    return 'BallFlight(fromX=' + this.bc3_1 + ', fromY=' + this.cc3_1 + ', targetX=' + this.dc3_1 + ', targetY=' + this.ec3_1 + ', progress=' + this.fc3_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.bc3_1);
    result = imul(result, 31) + getNumberHashCode(this.cc3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.dc3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ec3_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.fc3_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BallFlight))
      return false;
    var tmp0_other_with_cast = other instanceof BallFlight ? other : THROW_CCE();
    if (!equals(this.bc3_1, tmp0_other_with_cast.bc3_1))
      return false;
    if (!equals(this.cc3_1, tmp0_other_with_cast.cc3_1))
      return false;
    if (!equals(this.dc3_1, tmp0_other_with_cast.dc3_1))
      return false;
    if (!equals(this.ec3_1, tmp0_other_with_cast.ec3_1))
      return false;
    if (!equals(this.fc3_1, tmp0_other_with_cast.fc3_1))
      return false;
    return true;
  }
}
class HeroActor {
  constructor(parent, assets) {
    this.ic3_1 = assets;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.jc3_1 = addTo(this_0, parent);
    var tmp_0 = this;
    // Inline function 'korlibs.korge.view.sprite' call
    var this_1 = this.jc3_1;
    var initialAnimation = this.ic3_1.pc3_1;
    var anchor = Companion_getInstance().f28_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Sprite.ibs(initialAnimation, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.sprite.<anonymous>' call
    tmp_0.kc3_1 = addTo(this_2, this_1);
    var tmp_1 = this;
    // Inline function 'korlibs.korge.view.sprite' call
    var this_3 = this.jc3_1;
    var initialAnimation_0 = this.ic3_1.wc3_1;
    var anchor_0 = Companion_getInstance().c28_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Sprite.ibs(initialAnimation_0, anchor_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.sprite.<anonymous>' call
    tmp_1.lc3_1 = addTo(this_4, this_3);
    this.mc3_1 = 0.0;
    this.nc3_1 = 0.0;
    this.oc3_1 = null;
    position(this.jc3_1, 205.0, 594.0);
    scaleToHeight(this.kc3_1, 188.0);
    this.kc3_1.obs(this.ic3_1.pc3_1);
    scaleToHeight(this.lc3_1, 38.0);
    position(this.lc3_1, 64.0, -24.0);
    this.lc3_1.obs(this.ic3_1.wc3_1);
  }
  v2t() {
    position(this.jc3_1, 205.0, 594.0);
    this.kc3_1.nbe(Companion_getInstance_0().o28_1);
    this.mc3_1 = 0.0;
    this.nc3_1 = 0.0;
    this.oc3_1 = null;
    this.lc3_1.e8p(true);
    position(this.lc3_1, 64.0, -24.0);
    this.kc3_1.obs(this.ic3_1.pc3_1);
  }
  xc3(action) {
    switch (action.k3_1) {
      case 1:
        this.kc3_1.mbs(this.ic3_1.rc3_1);
        this.mc3_1 = 0.42;
        break;
      case 2:
        this.kc3_1.mbs(this.ic3_1.sc3_1);
        this.mc3_1 = 0.48;
        break;
      case 0:
        this.kc3_1.mbs(this.ic3_1.qc3_1);
        this.mc3_1 = 0.44;
        this.nc3_1 = 0.44;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  yc3(stageX, stageY) {
    this.oc3_1 = new BallFlight(64.0, -24.0, stageX - 205.0, stageY - 594.0, 0.0);
  }
  zc3(dt) {
    if (this.mc3_1 > 0.0) {
      this.mc3_1 = this.mc3_1 - dt;
      if (this.mc3_1 <= 0.0) {
        this.kc3_1.obs(this.ic3_1.pc3_1);
      }
    }
    if (this.nc3_1 > 0.0) {
      var tmp = this;
      // Inline function 'kotlin.math.max' call
      var b = this.nc3_1 - dt;
      tmp.nc3_1 = Math.max(0.0, b);
      var ratio = 1.0 - this.nc3_1 / 0.44;
      // Inline function 'kotlin.math.sin' call
      var x = ratio * 3.141592653589793;
      var tmp$ret$1 = Math.sin(x);
      this.jc3_1.iah(594.0 - tmp$ret$1 * 158.0);
    } else {
      this.jc3_1.iah(594.0);
    }
    var flight = this.oc3_1;
    if (!(flight == null)) {
      // Inline function 'kotlin.math.min' call
      var b_0 = flight.fc3_1 + dt * 3.2;
      var tmp$ret$2 = Math.min(1.0, b_0);
      var next = flight.hc3(VOID, VOID, VOID, VOID, tmp$ret$2);
      var outbound = next.fc3_1 <= 0.5;
      var ratio_0 = outbound ? next.fc3_1 / 0.5 : (next.fc3_1 - 0.5) / 0.5;
      var startX = outbound ? next.bc3_1 : next.dc3_1;
      var startY = outbound ? next.cc3_1 : next.ec3_1;
      var endX = outbound ? next.dc3_1 : next.bc3_1;
      var endY = outbound ? next.ec3_1 : next.cc3_1;
      var tmp_0 = lerp(startX, endX, ratio_0);
      var tmp_1 = lerp(startY, endY, ratio_0);
      // Inline function 'kotlin.math.sin' call
      var x_0 = ratio_0 * 3.141592653589793;
      var tmp$ret$3 = Math.sin(x_0);
      position(this.lc3_1, tmp_0, tmp_1 - tmp$ret$3 * 28.0);
      var tmp_2 = this;
      var tmp_3;
      if (next.fc3_1 >= 1.0) {
        position(this.lc3_1, next.bc3_1, next.cc3_1);
        tmp_3 = null;
      } else {
        tmp_3 = next;
      }
      tmp_2.oc3_1 = tmp_3;
    }
  }
}
class ObstacleActor {
  constructor(parent, assets, kind, startX, spawnLevel) {
    this.ac4_1 = assets;
    this.bc4_1 = kind;
    this.cc4_1 = spawnLevel;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.dc4_1 = addTo(this_0, parent);
    this.fc4_1 = 0.0;
    this.gc4_1 = 0.55;
    this.hc4_1 = 1.0;
    this.ic4_1 = 0.0;
    this.jc4_1 = true;
    this.kc4_1 = false;
    var tmp_0 = this;
    var tmp_1;
    switch (this.bc4_1.k3_1) {
      case 0:
        // Inline function 'kotlin.also' call

        // Inline function 'korlibs.korge.view.sprite' call

        var this_1 = this.dc4_1;
        var initialAnimation = this.ac4_1.tc3_1;
        var anchor = Companion_getInstance().f28_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_2 = Sprite.ibs(initialAnimation, anchor);
        // Inline function 'kotlin.apply' call

        var this_3 = addTo(this_2, this_1);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.sprite.<anonymous>' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'com.karandashov.viking.football.actors.ObstacleActor.<anonymous>' call

        scaleToHeight(this_3, 172.0);
        this_3.obs(this.ac4_1.tc3_1);
        tmp_1 = this_3;
        break;
      case 1:
        // Inline function 'kotlin.also' call

        // Inline function 'korlibs.korge.view.sprite' call

        var this_4 = this.dc4_1;
        var initialAnimation_0 = this.ac4_1.vc3_1;
        var anchor_0 = Companion_getInstance().f28_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_5 = Sprite.ibs(initialAnimation_0, anchor_0);
        // Inline function 'kotlin.apply' call

        var this_6 = addTo(this_5, this_4);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.sprite.<anonymous>' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'com.karandashov.viking.football.actors.ObstacleActor.<anonymous>' call

        scaleToHeight(this_6, 92.0);
        this_6.obs(this.ac4_1.vc3_1);
        tmp_1 = this_6;
        break;
      case 2:
        // Inline function 'kotlin.also' call

        // Inline function 'korlibs.korge.view.sprite' call

        var this_7 = this.dc4_1;
        var initialAnimation_1 = this.ac4_1.wc3_1;
        var anchor_1 = Companion_getInstance().c28_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_8 = Sprite.ibs(initialAnimation_1, anchor_1);
        // Inline function 'kotlin.apply' call

        var this_9 = addTo(this_8, this_7);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.sprite.<anonymous>' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'com.karandashov.viking.football.actors.ObstacleActor.<anonymous>' call

        scaleToHeight(this_9, 54.0);
        this_9.obs(this.ac4_1.wc3_1);
        tmp_1 = this_9;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp_0.ec4_1 = tmp_1;
    this.hc4_1 = this.ec4_1.lah();
    position(this.dc4_1, startX, initialY(this));
  }
  w6h() {
    return this.dc4_1.w6h();
  }
  lc4() {
    return this.bc4_1.k3_1 === 2 ? this.dc4_1.x6h() : 594.0 - this.ec4_1.qbe() * 0.45;
  }
  mc4() {
    return this.dc4_1.w6h() - this.ec4_1.pbe() * 0.5;
  }
  nc4() {
    return this.jc4_1;
  }
  oc4(dt, speed) {
    if (this.kc4_1)
      return Unit_instance;
    if (this.jc4_1) {
      var _receiver__tnumb7 = this.dc4_1;
      _receiver__tnumb7.hah(_receiver__tnumb7.w6h() - speed * dt * speedMultiplier(this));
      if (this.bc4_1.equals(ObstacleKind_FLYING_BALL_getInstance())) {
        this.ic4_1 = this.ic4_1 + dt;
        var tmp = initialY(this);
        // Inline function 'kotlin.math.min' call
        var b = this.ic4_1 * (86.0 + this.cc4_1 * 4.0);
        var tmp$ret$0 = Math.min(210.0, b);
        this.dc4_1.iah(tmp + tmp$ret$0);
      }
    } else {
      this.fc4_1 = this.fc4_1 - dt;
      var progress = 1.0 - coerceIn(this.fc4_1 / this.gc4_1, 0.0, 1.0);
      switch (this.bc4_1.k3_1) {
        case 0:
          var _receiver__tnumb7_0 = this.dc4_1;
          _receiver__tnumb7_0.hah(_receiver__tnumb7_0.w6h() - speed * dt * 0.42);
          // Inline function 'kotlin.math.max' call

          var b_0 = this.fc4_1 / this.gc4_1;
          var tmp$ret$1 = Math.max(0.0, b_0);
          this.ec4_1.rbe(tmp$ret$1);
          if (this.fc4_1 <= 0.0)
            this.kc4_1 = true;
          break;
        case 1:
          var _receiver__tnumb7_1 = this.dc4_1;
          _receiver__tnumb7_1.hah(_receiver__tnumb7_1.w6h() - speed * dt * 0.18);
          this.dc4_1.iah(594.0 - progress * 150.0);
          this.ec4_1.kah(this.hc4_1 * coerceAtLeast(1.0 - progress, 0.06));
          this.ec4_1.rbe(1.0);
          if (this.fc4_1 <= 0.0)
            this.kc4_1 = true;
          break;
        case 2:
          var _receiver__tnumb7_2 = this.dc4_1;
          _receiver__tnumb7_2.hah(_receiver__tnumb7_2.w6h() - speed * dt * 0.12);
          var _receiver__tnumb7_3 = this.dc4_1;
          _receiver__tnumb7_3.iah(_receiver__tnumb7_3.x6h() + dt * (520.0 + this.cc4_1 * 18.0));
          this.ec4_1.rbe(1.0);
          if (this.dc4_1.x6h() > 720.0 + 90.0)
            this.kc4_1 = true;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    if (this.dc4_1.w6h() < -170.0)
      this.kc4_1 = true;
  }
  pc4() {
    if (!this.jc4_1)
      return Unit_instance;
    this.jc4_1 = false;
    switch (this.bc4_1.k3_1) {
      case 0:
        this.gc4_1 = 0.55;
        this.fc4_1 = this.gc4_1;
        this.ec4_1.mbs(this.ac4_1.uc3_1);
        break;
      case 1:
        this.gc4_1 = 0.48;
        this.fc4_1 = this.gc4_1;
        break;
      case 2:
        this.gc4_1 = 1.0;
        this.fc4_1 = this.gc4_1;
        var _receiver__tnumb7 = this.ec4_1;
        _receiver__tnumb7.kah(_receiver__tnumb7.lah() * 1.18);
        this.hc4_1 = this.ec4_1.lah();
        var _receiver__tnumb7_0 = this.dc4_1;
        _receiver__tnumb7_0.iah(_receiver__tnumb7_0.x6h() - 12.0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  k6() {
    this.dc4_1.wai();
  }
}
class Companion {
  qc4($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_load__qllgda.bind(VOID, this), $completion);
  }
}
class GameAssets {
  constructor(heroRun, heroJump, heroKick, heroEat, playerRun, playerFall, robotDrive, ballSpin) {
    this.pc3_1 = heroRun;
    this.qc3_1 = heroJump;
    this.rc3_1 = heroKick;
    this.sc3_1 = heroEat;
    this.tc3_1 = playerRun;
    this.uc3_1 = playerFall;
    this.vc3_1 = robotDrive;
    this.wc3_1 = ballSpin;
  }
}
class RunningCityBackground {
  constructor(parent) {
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, parent);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    var tmp_0 = new BuildingRow(this_1, 7, 0.3, 210.0, 342.0, 0.55);
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, parent);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.rc4_1 = listOf([tmp_0, new BuildingRow(this_3, 6, 0.52, 145.0, 396.0, 0.66)]);
  }
  oc4(dt, speed) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.rc4_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'com.karandashov.viking.football.background.RunningCityBackground.update.<anonymous>' call
      element.oc4(dt, speed);
    }
  }
}
class BuildingRow {
  constructor(parent, count, speedFactor, baseY, spacing, alpha) {
    this.sc4_1 = speedFactor;
    this.tc4_1 = spacing;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, count);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.w1_1;
    var last = this_0.x1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.karandashov.viking.football.background.BuildingRow.buildings.<anonymous>' call
        var index = item;
        // Inline function 'korlibs.korge.view.container' call
        // Inline function 'korlibs.korge.view.addTo' call
        var this_1 = Container.sa3(false);
        // Inline function 'kotlin.apply' call
        var this_2 = addTo(this_1, parent);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.container.<anonymous>' call
        var tmp$ret$4 = new Building(this_2, index * this.tc4_1, baseY, alpha);
        destination.h(tmp$ret$4);
      }
       while (!(item === last));
    tmp.uc4_1 = destination;
  }
  oc4(dt, speed) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.uc4_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'com.karandashov.viking.football.background.BuildingRow.update.<anonymous>' call
      var _receiver__tnumb7 = element.vc4_1;
      _receiver__tnumb7.hah(_receiver__tnumb7.w6h() - speed * this.sc4_1 * dt);
      if (element.vc4_1.w6h() < -260.0) {
        // Inline function 'kotlin.collections.maxOf' call
        var iterator = this.uc4_1.a1();
        if (!iterator.b1())
          throw NoSuchElementException.o6();
        // Inline function 'com.karandashov.viking.football.background.BuildingRow.update.<anonymous>.<anonymous>' call
        var maxValue = iterator.c1().vc4_1.w6h();
        while (iterator.b1()) {
          // Inline function 'com.karandashov.viking.football.background.BuildingRow.update.<anonymous>.<anonymous>' call
          var v = iterator.c1().vc4_1.w6h();
          // Inline function 'kotlin.comparisons.maxOf' call
          var a = maxValue;
          maxValue = Math.max(a, v);
        }
        var rightMost = maxValue;
        element.ac5(rightMost + this.tc4_1);
      }
    }
  }
}
class Building {
  constructor(root, startX, baseY, alpha) {
    this.vc4_1 = root;
    this.wc4_1 = Random(roundToInt(startX) + imul(roundToInt(baseY), 37) | 0);
    this.xc4_1 = this.wc4_1.so(95.0, 170.0);
    this.yc4_1 = this.wc4_1.so(82.0, 172.0);
    this.zc4_1 = Companion_getInstance_4().r4d(35, 82, 112, roundToInt(alpha * 255));
    position(this.vc4_1, startX, baseY);
    draw(this);
  }
  ac5(nextX) {
    this.vc4_1.hah(nextX + this.wc4_1.so(-18.0, 28.0));
  }
}
class VikingFootballGame {
  constructor(stage) {
    this.gc2_1 = stage;
    this.sc2_1 = Random(7);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.tc2_1 = ArrayList.i1();
    this.uc2_1 = GameState_READY_getInstance();
    this.vc2_1 = false;
    this.wc2_1 = 0.0;
    this.xc2_1 = 180.0;
    this.yc2_1 = 2.4;
    this.zc2_1 = 2.6;
  }
  ac3($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this), $completion);
  }
}
class Action extends Enum {}
class GameState extends Enum {}
class ObstacleKind extends Enum {}
class ActionButton {
  constructor(parent, label, keyHint, x, y, onPress) {
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.sc5_1 = addTo(this_0, parent);
    position(this.sc5_1, x, y);
    // Inline function 'korlibs.korge.view.roundRect' call
    var this_1 = this.sc5_1;
    var size = Size2D.h2h(132.0, 62.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_1();
    var radius = new RectCorners(numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0));
    var fill = new RGBA(get_UiPanel());
    var stroke = new RGBA(RGBA__withA_impl_vogscm(get_UiDark(), 80));
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = RoundRect.qbm(size, radius, fill, stroke, 2.0, true);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.ActionButton.<anonymous>' call
    // Inline function 'korlibs.korge.input.onDown' call
    var handler = ActionButton$lambda(onPress);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory();
    var tmp1_safe_receiver = this_3 == null ? null : this_3.uag();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop.get(tmp1_safe_receiver_0);
          tmp_0.n1z(ActionButton$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.view.text' call
    var this_4 = this.sc5_1;
    var color = get_UiDark();
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_5().h4n_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_5 = Text.zbw(label, numberToDouble(23.0), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_6 = addTo(this_5, this_4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.ActionButton.<anonymous>' call
    position(this_6, 18.0, 9.0);
    // Inline function 'korlibs.korge.view.text' call
    var this_7 = this.sc5_1;
    var color_0 = RGBA__withA_impl_vogscm(get_UiDark(), 145);
    var font_0 = get_DefaultTtfFontAsBitmap();
    var alignment_0 = Companion_getInstance_5().h4n_1;
    var renderer_0 = get_DefaultStringTextRenderer();
    var autoScaling_0 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_8 = Text.zbw(keyHint, numberToDouble(12.0), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
    // Inline function 'kotlin.apply' call
    var this_9 = addTo(this_8, this_7);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.ActionButton.<anonymous>' call
    position(this_9, 20.0, 38.0);
  }
}
class EndOverlay {
  constructor(parent, onRestart) {
    this.bc5_1 = onRestart;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.cc5_1 = addTo(this_0, parent);
    this.cc5_1.e8p(false);
    // Inline function 'korlibs.korge.view.solidRect' call
    var this_1 = this.cc5_1;
    var color = Companion_getInstance_4().r4d(0, 0, 0, 138);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = SolidRect.bbp(Size2D.h2h(1280.0, 720.0), color);
    // Inline function 'kotlin.apply' call
    addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var tmp_0 = this;
    // Inline function 'korlibs.korge.view.text' call
    var this_3 = this.cc5_1;
    var color_0 = Colors_getInstance().h3z_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_5().h4n_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Text.zbw('', numberToDouble(72.0), color_0, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    tmp_0.dc5_1 = addTo(this_4, this_3);
    position(this.dc5_1, 478.0, 232.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var this_5 = this.cc5_1;
    var size = Size2D.h2h(206.0, 62.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_1();
    var radius = new RectCorners(numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0));
    var fill = new RGBA(Colors_getInstance().h3z_1);
    var stroke = new RGBA(Colors_getInstance().h3z_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = RoundRect.qbm(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(this_6, this_5);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.EndOverlay.<anonymous>' call
    position(this_7, 537.0, 356.0);
    // Inline function 'korlibs.korge.input.onDown' call
    var handler = EndOverlay$lambda(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory_0();
    var tmp1_safe_receiver = this_7 == null ? null : this_7.uag();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_1 = prop.get(tmp1_safe_receiver_0);
          tmp_1.n1z(EndOverlay$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.view.text' call
    var this_8 = this.cc5_1;
    var text = '\u0417\u0410\u041D\u041E\u0412\u041E';
    var color_1 = get_UiDark();
    var font_0 = get_DefaultTtfFontAsBitmap();
    var alignment_0 = Companion_getInstance_5().h4n_1;
    var renderer_0 = get_DefaultStringTextRenderer();
    var autoScaling_0 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_9 = Text.zbw(text, numberToDouble(25.0), color_1, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
    // Inline function 'kotlin.apply' call
    var this_10 = addTo(this_9, this_8);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.EndOverlay.<anonymous>' call
    position(this_10, 592.0, 372.0);
  }
  oc5(message) {
    this.dc5_1.abx(message);
    this.dc5_1.hah(message === '\u041F\u041E\u0411\u0415\u0414\u0410' ? 520.0 : 463.0);
    this.cc5_1.e8p(true);
  }
  ec5() {
    this.cc5_1.e8p(false);
  }
}
class FullscreenButton {
  constructor(parent, onPress) {
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.tc5_1 = addTo(this_0, parent);
    position(this.tc5_1, 1190.0, 22.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var this_1 = this.tc5_1;
    var size = Size2D.h2h(66.0, 42.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_1();
    var radius = new RectCorners(numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0));
    var fill = new RGBA(RGBA__withA_impl_vogscm(Colors_getInstance().h3z_1, 220));
    var stroke = new RGBA(RGBA__withA_impl_vogscm(get_UiDark(), 90));
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = RoundRect.qbm(size, radius, fill, stroke, 2.0, true);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.FullscreenButton.<anonymous>' call
    // Inline function 'korlibs.korge.input.onDown' call
    var handler = FullscreenButton$lambda(onPress);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory_1();
    var tmp1_safe_receiver = this_3 == null ? null : this_3.uag();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop.get(tmp1_safe_receiver_0);
          tmp_0.n1z(FullscreenButton$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.view.text' call
    var this_4 = this.tc5_1;
    var text = '\u042D\u041A\u0420\u0410\u041D';
    var color = get_UiDark();
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_5().h4n_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_5 = Text.zbw(text, numberToDouble(14.0), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_6 = addTo(this_5, this_4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.FullscreenButton.<anonymous>' call
    position(this_6, 10.0, 12.0);
  }
}
class Hud {
  constructor(parent) {
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.fc5_1 = addTo(this_0, parent);
    var tmp_0 = this;
    // Inline function 'korlibs.korge.view.text' call
    var this_1 = this.fc5_1;
    var text = '\u0423\u0420\u041E\u0412\u0415\u041D\u042C 1';
    var color = get_UiDark();
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_5().h4n_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Text.zbw(text, numberToDouble(28.0), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    tmp_0.gc5_1 = addTo(this_2, this_1);
    var tmp_1 = this;
    // Inline function 'korlibs.korge.view.text' call
    var this_3 = this.fc5_1;
    var text_0 = '\u041E\u0421\u0422\u0410\u041B\u041E\u0421\u042C 0:00';
    var color_0 = RGBA__withA_impl_vogscm(get_UiDark(), 210);
    var font_0 = get_DefaultTtfFontAsBitmap();
    var alignment_0 = Companion_getInstance_5().h4n_1;
    var renderer_0 = get_DefaultStringTextRenderer();
    var autoScaling_0 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Text.zbw(text_0, numberToDouble(22.0), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    tmp_1.hc5_1 = addTo(this_4, this_3);
    var tmp_2 = this;
    // Inline function 'korlibs.korge.view.text' call
    var this_5 = this.fc5_1;
    var text_1 = '\u041F\u0420\u041E\u0411\u0415\u041B - \u0423\u0414\u0410\u0420    \u0412\u0412\u0415\u0420\u0425 - \u041F\u0420\u042B\u0416\u041E\u041A    \u0412\u041F\u0420\u0410\u0412\u041E - \u0421\u042A\u0415\u0421\u0422\u042C';
    var color_1 = RGBA__withA_impl_vogscm(get_UiDark(), 180);
    var font_1 = get_DefaultTtfFontAsBitmap();
    var alignment_1 = Companion_getInstance_5().h4n_1;
    var renderer_1 = get_DefaultStringTextRenderer();
    var autoScaling_1 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = Text.zbw(text_1, numberToDouble(18.0), color_1, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    tmp_2.ic5_1 = addTo(this_6, this_5);
    position(this.fc5_1, 28.0, 24.0);
    position(this.hc5_1, 0.0, 38.0);
    position(this.ic5_1, 0.0, 644.0);
  }
  jc5(level, secondsLeft) {
    this.gc5_1.abx('\u0423\u0420\u041E\u0412\u0415\u041D\u042C ' + level);
    this.hc5_1.abx('\u041E\u0421\u0422\u0410\u041B\u041E\u0421\u042C ' + formatSeconds(secondsLeft));
  }
}
class OrientationOverlay {
  constructor(parent, onFullscreen) {
    this.pc5_1 = onFullscreen;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.qc5_1 = addTo(this_0, parent);
    this.qc5_1.e8p(false);
    // Inline function 'korlibs.korge.view.solidRect' call
    var this_1 = this.qc5_1;
    var color = Companion_getInstance_4().r4d(0, 0, 0, 182);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = SolidRect.bbp(Size2D.h2h(1280.0, 720.0), color);
    // Inline function 'kotlin.apply' call
    addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    // Inline function 'korlibs.korge.view.text' call
    var this_3 = this.qc5_1;
    var text = '\u041F\u041E\u0412\u0415\u0420\u041D\u0418\u0422\u0415 \u042D\u041A\u0420\u0410\u041D';
    var color_0 = Colors_getInstance().h3z_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_5().h4n_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Text.zbw(text, numberToDouble(52.0), color_0, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.OrientationOverlay.<anonymous>' call
    position(this_5, 352.0, 214.0);
    // Inline function 'korlibs.korge.view.text' call
    var this_6 = this.qc5_1;
    var text_0 = '\u0414\u043B\u044F \u0438\u0433\u0440\u044B \u043D\u0443\u0436\u0435\u043D \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C.';
    var color_1 = RGBA__withA_impl_vogscm(Colors_getInstance().h3z_1, 230);
    var font_0 = get_DefaultTtfFontAsBitmap();
    var alignment_0 = Companion_getInstance_5().h4n_1;
    var renderer_0 = get_DefaultStringTextRenderer();
    var autoScaling_0 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = Text.zbw(text_0, numberToDouble(24.0), color_1, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, this_6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.OrientationOverlay.<anonymous>' call
    position(this_8, 422.0, 294.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var this_9 = this.qc5_1;
    var size = Size2D.h2h(222.0, 58.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_1();
    var radius = new RectCorners(numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0));
    var fill = new RGBA(Colors_getInstance().h3z_1);
    var stroke = new RGBA(Colors_getInstance().h3z_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_10 = RoundRect.qbm(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_11 = addTo(this_10, this_9);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.OrientationOverlay.<anonymous>' call
    position(this_11, 529.0, 378.0);
    // Inline function 'korlibs.korge.input.onDown' call
    var handler = OrientationOverlay$lambda(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory_2();
    var tmp1_safe_receiver = this_11 == null ? null : this_11.uag();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop.get(tmp1_safe_receiver_0);
          tmp_0.n1z(OrientationOverlay$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.view.text' call
    var this_12 = this.qc5_1;
    var text_1 = '\u0412\u0415\u0421\u042C \u042D\u041A\u0420\u0410\u041D';
    var color_2 = get_UiDark();
    var font_1 = get_DefaultTtfFontAsBitmap();
    var alignment_1 = Companion_getInstance_5().h4n_1;
    var renderer_1 = get_DefaultStringTextRenderer();
    var autoScaling_1 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_13 = Text.zbw(text_1, numberToDouble(22.0), color_2, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
    // Inline function 'kotlin.apply' call
    var this_14 = addTo(this_13, this_12);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.OrientationOverlay.<anonymous>' call
    position(this_14, 574.0, 395.0);
  }
  rc5(isPortrait) {
    this.qc5_1.e8p(isPortrait);
  }
}
class StartOverlay {
  constructor(parent, onStart, onFullscreen) {
    this.kc5_1 = onStart;
    this.lc5_1 = onFullscreen;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.mc5_1 = addTo(this_0, parent);
    // Inline function 'korlibs.korge.view.solidRect' call
    var this_1 = this.mc5_1;
    var color = Companion_getInstance_4().r4d(0, 0, 0, 112);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = SolidRect.bbp(Size2D.h2h(1280.0, 720.0), color);
    // Inline function 'kotlin.apply' call
    addTo(this_2, this_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    // Inline function 'korlibs.korge.view.text' call
    var this_3 = this.mc5_1;
    var text = 'VIKING FOOTBALL';
    var color_0 = Colors_getInstance().h3z_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_5().h4n_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Text.zbw(text, numberToDouble(56.0), color_0, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_5, 382.0, 142.0);
    // Inline function 'korlibs.korge.view.text' call
    var this_6 = this.mc5_1;
    var text_0 = '\u041F\u0440\u043E\u0431\u0435\u043B - \u0443\u0434\u0430\u0440 \u043F\u043E \u0438\u0433\u0440\u043E\u043A\u0430\u043C. \u0412\u0432\u0435\u0440\u0445 - \u043F\u043E\u0439\u043C\u0430\u0442\u044C \u043C\u044F\u0447. \u0412\u043F\u0440\u0430\u0432\u043E - \u0441\u044A\u0435\u0441\u0442\u044C \u0440\u043E\u0431\u043E\u0442\u0430 \u0440\u044F\u0434\u043E\u043C.';
    var color_1 = RGBA__withA_impl_vogscm(Colors_getInstance().h3z_1, 235);
    var font_0 = get_DefaultTtfFontAsBitmap();
    var alignment_0 = Companion_getInstance_5().h4n_1;
    var renderer_0 = get_DefaultStringTextRenderer();
    var autoScaling_0 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = Text.zbw(text_0, numberToDouble(22.0), color_1, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, this_6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_8, 230.0, 240.0);
    // Inline function 'korlibs.korge.view.text' call
    var this_9 = this.mc5_1;
    var text_1 = '\u041F\u0440\u043E\u0434\u0435\u0440\u0436\u0438\u0441\u044C \u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u043F\u0435\u0441\u043D\u0438. \u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0440\u0430\u0441\u0442\u0451\u0442 \u043A\u0430\u0436\u0434\u044B\u0435 20 \u0441\u0435\u043A\u0443\u043D\u0434.';
    var color_2 = RGBA__withA_impl_vogscm(Colors_getInstance().h3z_1, 220);
    var font_1 = get_DefaultTtfFontAsBitmap();
    var alignment_1 = Companion_getInstance_5().h4n_1;
    var renderer_1 = get_DefaultStringTextRenderer();
    var autoScaling_1 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_10 = Text.zbw(text_1, numberToDouble(22.0), color_2, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
    // Inline function 'kotlin.apply' call
    var this_11 = addTo(this_10, this_9);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_11, 322.0, 278.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var this_12 = this.mc5_1;
    var size = Size2D.h2h(184.0, 64.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_1();
    var radius = new RectCorners(numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0));
    var fill = new RGBA(Colors_getInstance().h3z_1);
    var stroke = new RGBA(Colors_getInstance().h3z_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_13 = RoundRect.qbm(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_14 = addTo(this_13, this_12);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_14, 548.0, 366.0);
    // Inline function 'korlibs.korge.input.onDown' call
    var handler = StartOverlay$lambda(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory_3();
    var tmp1_safe_receiver = this_14 == null ? null : this_14.uag();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop.get(tmp1_safe_receiver_0);
          tmp_0.n1z(StartOverlay$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.view.text' call
    var this_15 = this.mc5_1;
    var text_2 = '\u0421\u0422\u0410\u0420\u0422';
    var color_3 = get_UiDark();
    var font_2 = get_DefaultTtfFontAsBitmap();
    var alignment_2 = Companion_getInstance_5().h4n_1;
    var renderer_2 = get_DefaultStringTextRenderer();
    var autoScaling_2 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_16 = Text.zbw(text_2, numberToDouble(28.0), color_3, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
    // Inline function 'kotlin.apply' call
    var this_17 = addTo(this_16, this_15);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_17, 598.0, 383.0);
    // Inline function 'korlibs.korge.view.roundRect' call
    var this_18 = this.mc5_1;
    var size_0 = Size2D.h2h(184.0, 44.0);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_1();
    var radius_0 = new RectCorners(numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0), numberToDouble(8.0));
    var fill_0 = new RGBA(RGBA__withA_impl_vogscm(Colors_getInstance().h3z_1, 210));
    var stroke_0 = new RGBA(Colors_getInstance().h3z_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_19 = RoundRect.qbm(size_0, radius_0, fill_0, stroke_0, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_20 = addTo(this_19, this_18);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_20, 548.0, 444.0);
    // Inline function 'korlibs.korge.input.onDown' call
    var handler_0 = StartOverlay$lambda_1(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_0 = down$factory_4();
    var tmp1_safe_receiver_1 = this_20 == null ? null : this_20.uag();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < tmp1_safe_receiver_1.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.d1(_unary__edvuaz_0);
        var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
        if (tmp1_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_1 = prop_0.get(tmp1_safe_receiver_2);
          tmp_1.n1z(StartOverlay$lambda_2(handler_0));
        }
      }
    }
    // Inline function 'korlibs.korge.view.text' call
    var this_21 = this.mc5_1;
    var text_3 = '\u0412\u0415\u0421\u042C \u042D\u041A\u0420\u0410\u041D';
    var color_4 = get_UiDark();
    var font_3 = get_DefaultTtfFontAsBitmap();
    var alignment_3 = Companion_getInstance_5().h4n_1;
    var renderer_3 = get_DefaultStringTextRenderer();
    var autoScaling_3 = Companion_instance.vbw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_22 = Text.zbw(text_3, numberToDouble(18.0), color_4, font_3, alignment_3, renderer_3, autoScaling_3, null, null);
    // Inline function 'kotlin.apply' call
    var this_23 = addTo(this_22, this_21);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.karandashov.viking.football.ui.StartOverlay.<anonymous>' call
    position(this_23, 581.0, 456.0);
  }
  nc5() {
    this.mc5_1.e8p(true);
  }
  ec5() {
    this.mc5_1.e8p(false);
  }
}
//endregion
function *_generator_main__qlaff5($completion) {
  var tmp0_windowSize = Size2D.h2h(1280.0, 720.0);
  var tmp1_virtualSize = Size2D.h2h(1280.0, 720.0);
  var tmp2_displayMode = Companion_getInstance_2().r9o_1;
  var tmp3_backgroundColor = get_SkyColor();
  var tmp = Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_windowSize, VOID, VOID, tmp1_virtualSize, VOID, VOID, VOID, tmp2_displayMode, 'Viking Football', VOID, tmp3_backgroundColor, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function main($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_main__qlaff5.bind(VOID), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$Korge, $completion) {
  var tmp = (new VikingFootballGame($this$Korge)).ac3($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.a9m($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
function initialY($this) {
  var tmp;
  switch ($this.bc4_1.k3_1) {
    case 0:
      tmp = 594.0;
      break;
    case 1:
      tmp = 594.0;
      break;
    case 2:
      tmp = 118.0 + ($this.cc4_1 % 3 | 0) * 20.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function speedMultiplier($this) {
  var tmp;
  switch ($this.bc4_1.k3_1) {
    case 0:
      tmp = 1.0;
      break;
    case 1:
      tmp = 0.86;
      break;
    case 2:
      tmp = 0.96;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function *_generator_load__qllgda($this, $completion) {
  var tmp = animation($this, 'viking_hero/run/viking_hero_run', 6, 72, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = animation($this, 'viking_hero/jump/viking_hero_jump', 4, 78, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = animation($this, 'viking_hero/kick/viking_hero_kick', 4, 64, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = animation($this, 'viking_hero/eat/viking_hero_eat', 4, 78, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = animation($this, 'player/run/player_run', 4, 82, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = animation($this, 'player/fall/player_fall', 4, 88, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = animation($this, 'delivery_robot/drive/delivery_robot_drive', 3, 88, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = animation($this, 'soccer_ball/spin/soccer_ball_spin', 3, 65, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return new GameAssets(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6);
}
function *_generator_animation__yve0k0($this, path, frames, frameMs, $completion) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = numberRangeToNumber(1, frames);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.w1_1;
  var last = this_0.x1_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.karandashov.viking.football.assets.Companion.animation.<anonymous>' call
      var index = item;
      var tmp = readBitmapSlice(get_resourcesVfs().ei('assets/sprites/' + path + '_' + padStart(index.toString(), 2, _Char___init__impl__6a9atx(48)) + '.png'), VOID, VOID, VOID, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var tmp$ret$0 = tmp;
      destination.h(tmp$ret$0);
    }
     while (!(item === last));
  var tmp_0 = destination;
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_3();
  var tmp$ret$4 = toDuration(frameMs, DurationUnit_MILLISECONDS_getInstance());
  return SpriteAnimation.qbs(tmp_0, tmp$ret$4);
}
function animation($this, path, frames, frameMs, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_animation__yve0k0.bind(VOID, $this, path, frames, frameMs), $completion);
}
var Companion_instance_1;
function Companion_getInstance_6() {
  return Companion_instance_1;
}
function draw($this) {
  var y0 = 0.0;
  var y1 = -$this.yc4_1;
  // Inline function 'korlibs.korge.view.line' call
  var this_0 = $this.vc4_1;
  var color = $this.zc4_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Line.ubg(Vector2D.d2b(0.0, y0), Vector2D.d2b(0.0, y1), color);
  // Inline function 'kotlin.apply' call
  addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.line.<anonymous>' call
  // Inline function 'korlibs.korge.view.line' call
  var this_2 = $this.vc4_1;
  var x0 = $this.xc4_1;
  var x1 = $this.xc4_1;
  var color_0 = $this.zc4_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = Line.ubg(Vector2D.d2b(x0, y0), Vector2D.d2b(x1, y1), color_0);
  // Inline function 'kotlin.apply' call
  addTo(this_3, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.line.<anonymous>' call
  // Inline function 'korlibs.korge.view.line' call
  var this_4 = $this.vc4_1;
  var x1_0 = $this.xc4_1;
  var color_1 = $this.zc4_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = Line.ubg(Vector2D.d2b(0.0, y1), Vector2D.d2b(x1_0, y1), color_1);
  // Inline function 'kotlin.apply' call
  addTo(this_5, this_4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.line.<anonymous>' call
  // Inline function 'korlibs.korge.view.line' call
  var this_6 = $this.vc4_1;
  var x0_0 = -8.0;
  var x1_1 = $this.xc4_1 + 8.0;
  var color_2 = RGBA__withA_impl_vogscm($this.zc4_1, roundToInt(_RGBA___get_a__impl__6msvu7($this.zc4_1) * 0.7));
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Line.ubg(Vector2D.d2b(x0_0, y0), Vector2D.d2b(x1_1, y0), color_2);
  // Inline function 'kotlin.apply' call
  addTo(this_7, this_6);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.line.<anonymous>' call
  // Inline function 'kotlin.math.max' call
  // Inline function 'kotlin.math.floor' call
  var x = $this.yc4_1 / 42.0;
  var tmp$ret$16 = Math.floor(x);
  var b = numberToInt(tmp$ret$16);
  var floors = Math.max(2, b);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < floors)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.karandashov.viking.football.background.Building.draw.<anonymous>' call
      var y = y1 + 24.0 + index * 38.0;
      // Inline function 'korlibs.korge.view.line' call
      var this_8 = $this.vc4_1;
      var x1_2 = $this.xc4_1 - 14.0;
      var color_3 = RGBA__withA_impl_vogscm($this.zc4_1, roundToInt(_RGBA___get_a__impl__6msvu7($this.zc4_1) * 0.7));
      // Inline function 'korlibs.korge.view.addTo' call
      var this_9 = Line.ubg(Vector2D.d2b(14.0, y), Vector2D.d2b(x1_2, y), color_3);
      // Inline function 'kotlin.apply' call
      addTo(this_9, this_8);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.line.<anonymous>' call
    }
     while (inductionVariable < floors);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.math.ceil' call
  var x_0 = $this.xc4_1 / 42.0;
  var tmp$ret$22 = Math.ceil(x_0);
  var times = numberToInt(tmp$ret$22);
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < times)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.karandashov.viking.football.background.Building.draw.<anonymous>' call
      var x_1 = 22.0 + index_0 * 40.0;
      // Inline function 'korlibs.korge.view.line' call
      var this_10 = $this.vc4_1;
      var y0_0 = y1 + 16.0;
      var y1_0 = y0 - 12.0;
      var color_4 = RGBA__withA_impl_vogscm($this.zc4_1, roundToInt(_RGBA___get_a__impl__6msvu7($this.zc4_1) * 0.58));
      // Inline function 'korlibs.korge.view.addTo' call
      var this_11 = Line.ubg(Vector2D.d2b(x_1, y0_0), Vector2D.d2b(x_1, y1_0), color_4);
      // Inline function 'kotlin.apply' call
      addTo(this_11, this_10);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.line.<anonymous>' call
    }
     while (inductionVariable_0 < times);
}
function get_SkyColor() {
  _init_properties_GameConfig_kt__ajt58();
  return SkyColor;
}
var SkyColor;
function get_TurfColor() {
  _init_properties_GameConfig_kt__ajt58();
  return TurfColor;
}
var TurfColor;
function get_TurfDarkColor() {
  _init_properties_GameConfig_kt__ajt58();
  return TurfDarkColor;
}
var TurfDarkColor;
function get_UiDark() {
  _init_properties_GameConfig_kt__ajt58();
  return UiDark;
}
var UiDark;
function get_UiPanel() {
  _init_properties_GameConfig_kt__ajt58();
  return UiPanel;
}
var UiPanel;
var properties_initialized_GameConfig_kt_snonrq;
function _init_properties_GameConfig_kt__ajt58() {
  if (!properties_initialized_GameConfig_kt_snonrq) {
    properties_initialized_GameConfig_kt_snonrq = true;
    SkyColor = Companion_getInstance_4().y4e(184, 226, 249);
    TurfColor = Companion_getInstance_4().y4e(84, 190, 88);
    TurfDarkColor = Companion_getInstance_4().y4e(45, 126, 62);
    UiDark = Companion_getInstance_4().y4e(22, 38, 50);
    UiPanel = Companion_getInstance_4().r4d(255, 255, 255, 210);
  }
}
function _get_assets__q50yjs($this) {
  var tmp = $this.hc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('assets');
  }
}
function _get_music__e2e0tw($this) {
  var tmp = $this.ic2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('music');
  }
}
function _get_musicChannel__fsyvwz($this) {
  var tmp = $this.jc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('musicChannel');
  }
}
function _get_hero__d7k13l($this) {
  var tmp = $this.kc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('hero');
  }
}
function _get_background__3vp7tv($this) {
  var tmp = $this.lc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('background');
  }
}
function _get_hud__e69vne($this) {
  var tmp = $this.mc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('hud');
  }
}
function _get_overlay__r3wklb($this) {
  var tmp = $this.nc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('overlay');
  }
}
function _get_startOverlay__6k8cjh($this) {
  var tmp = $this.oc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('startOverlay');
  }
}
function _get_orientationOverlay__a6k3it($this) {
  var tmp = $this.pc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('orientationOverlay');
  }
}
function _get_obstacleLayer__sz6q6n($this) {
  var tmp = $this.qc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('obstacleLayer');
  }
}
function _get_controlsLayer__auk7be($this) {
  var tmp = $this.rc2_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('controlsLayer');
  }
}
function *_generator_start__v5y7pu($this, $completion) {
  var tmp = $this;
  var tmp_0 = Companion_instance_1.qc4($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.hc2_1 = tmp_0;
  var tmp_1 = $this;
  var tmp_2 = readMusic(get_resourcesVfs().ei('music/compressed.mp3'), VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  tmp_1.ic2_1 = tmp_2;
  var tmp_3 = $this;
  // Inline function 'kotlin.takeIf' call
  var this_0 = get_seconds(_get_music__e2e0tw($this).j67());
  // Inline function 'kotlin.contracts.contract' call
  var tmp_4;
  // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.start.<anonymous>' call
  if (isFinite(this_0) && this_0 > 1.0) {
    tmp_4 = this_0;
  } else {
    tmp_4 = null;
  }
  var tmp0_elvis_lhs = tmp_4;
  tmp_3.xc2_1 = tmp0_elvis_lhs == null ? 180.0 : tmp0_elvis_lhs;
  buildScene($this);
  setupInput($this);
  prepareStart($this);
  addUpdater($this.gc2_1, VikingFootballGame$start$lambda($this));
  return Unit_instance;
}
function buildScene($this) {
  // Inline function 'korlibs.korge.view.solidRect' call
  var this_0 = $this.gc2_1;
  var color = get_SkyColor();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = SolidRect.bbp(Size2D.h2h(1280.0, 720.0), color);
  // Inline function 'kotlin.apply' call
  addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var tmp = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_2 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp.lc2_1 = new RunningCityBackground(this_4);
  // Inline function 'korlibs.korge.view.solidRect' call
  var this_5 = $this.gc2_1;
  var color_0 = get_TurfColor();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = SolidRect.bbp(Size2D.h2h(1280.0, 92.0), color_0);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, this_5);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.buildScene.<anonymous>' call
  position(this_7, 0.0, 520.0);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < 9)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.buildScene.<anonymous>' call
      // Inline function 'korlibs.korge.view.line' call
      var this_8 = $this.gc2_1;
      var x0 = index * 160.0 - 20.0;
      var y0 = 520.0 + 19.0;
      var x1 = index * 160.0 + 90.0;
      var y1 = 520.0 + 44.0;
      var color_1 = RGBA__withA_impl_vogscm(get_TurfDarkColor(), 70);
      // Inline function 'korlibs.korge.view.addTo' call
      var this_9 = Line.ubg(Vector2D.d2b(x0, y0), Vector2D.d2b(x1, y1), color_1);
      // Inline function 'kotlin.apply' call
      addTo(this_9, this_8);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.line.<anonymous>' call
    }
     while (inductionVariable < 9);
  var tmp_0 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_10 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp_0.qc2_1 = addTo(this_11, this_10);
  var tmp_1 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_12 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_13 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  var this_14 = addTo(this_13, this_12);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp_1.kc2_1 = new HeroActor(this_14, _get_assets__q50yjs($this));
  var tmp_2 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_15 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_16 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  var this_17 = addTo(this_16, this_15);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp_2.mc2_1 = new Hud(this_17);
  var tmp_3 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_18 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_19 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp_3.rc2_1 = addTo(this_19, this_18);
  // Inline function 'korlibs.korge.view.container' call
  var this_20 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_21 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_4 = addTo(this_21, this_20);
  new FullscreenButton(tmp_4, VikingFootballGame$enterFullscreenMode$ref($this));
  var tmp_5 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_22 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_23 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_6 = addTo(this_23, this_22);
  tmp_5.nc2_1 = new EndOverlay(tmp_6, VikingFootballGame$resetGame$ref($this));
  var tmp_7 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_24 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_25 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_8 = addTo(this_25, this_24);
  var tmp_9 = VikingFootballGame$resetGame$ref_0($this);
  tmp_7.oc2_1 = new StartOverlay(tmp_8, tmp_9, VikingFootballGame$enterFullscreenMode$ref_0($this));
  var tmp_10 = $this;
  // Inline function 'korlibs.korge.view.container' call
  var this_26 = $this.gc2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_27 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_11 = addTo(this_27, this_26);
  tmp_10.pc2_1 = new OrientationOverlay(tmp_11, VikingFootballGame$enterFullscreenMode$ref_1($this));
  setPortraitBlocked($this, isPortraitOrientation());
  installOrientationWatcher(VikingFootballGame$setPortraitBlocked$ref($this));
}
function setupInput($this) {
  // Inline function 'korlibs.korge.input.keys' call
  var this_0 = $this.gc2_1;
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.setupInput.<anonymous>' call
  var $this$keys = get_keys(this_0);
  var tmp = Key_SPACE_getInstance();
  $this$keys.i9y(tmp, VikingFootballGame$setupInput$lambda($this));
  var tmp_0 = Key_UP_getInstance();
  $this$keys.i9y(tmp_0, VikingFootballGame$setupInput$lambda_0($this));
  var tmp_1 = Key_RIGHT_getInstance();
  $this$keys.i9y(tmp_1, VikingFootballGame$setupInput$lambda_1($this));
  // Inline function 'korlibs.korge.view.container' call
  var this_1 = _get_controlsLayer__auk7be($this);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_2 = addTo(this_2, this_1);
  new ActionButton(tmp_2, '\u041F\u0420\u042B\u0416\u041E\u041A', '\u0412\u0412\u0415\u0420\u0425', 1115.0, 398.0, VikingFootballGame$setupInput$lambda_2($this));
  // Inline function 'korlibs.korge.view.container' call
  var this_3 = _get_controlsLayer__auk7be($this);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_3 = addTo(this_4, this_3);
  new ActionButton(tmp_3, '\u0423\u0414\u0410\u0420', '\u041F\u0420\u041E\u0411\u0415\u041B', 1115.0, 492.0, VikingFootballGame$setupInput$lambda_3($this));
  // Inline function 'korlibs.korge.view.container' call
  var this_5 = _get_controlsLayer__auk7be($this);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Container.sa3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var tmp_4 = addTo(this_6, this_5);
  new ActionButton(tmp_4, '\u0421\u042A\u0415\u0421\u0422\u042C', '\u0412\u041F\u0420\u0410\u0412\u041E', 1115.0, 586.0, VikingFootballGame$setupInput$lambda_4($this));
}
function prepareStart($this) {
  if (!($this.jc2_1 == null)) {
    _get_musicChannel__fsyvwz($this).r5s();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.tc2_1.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.prepareStart.<anonymous>' call
    element.k6();
  }
  $this.tc2_1.e3();
  $this.wc2_1 = 0.0;
  $this.yc2_1 = 2.2;
  $this.zc2_1 = 2.6;
  $this.uc2_1 = GameState_READY_getInstance();
  _get_overlay__r3wklb($this).ec5();
  _get_hero__d7k13l($this).v2t();
  _get_hud__e69vne($this).jc5(1, $this.xc2_1);
  _get_startOverlay__6k8cjh($this).nc5();
}
function resetGame($this) {
  unlockMobileAudio();
  requestLandscapeOrientation();
  _get_overlay__r3wklb($this).ec5();
  _get_startOverlay__6k8cjh($this).ec5();
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    preloadMusicForMobile('music/compressed.mp3');
    tmp = _Result___init__impl__xyqfz8(Unit_instance);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  beginRun($this);
}
function beginRun($this) {
  if (!($this.jc2_1 == null)) {
    _get_musicChannel__fsyvwz($this).r5s();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.tc2_1.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.beginRun.<anonymous>' call
    element.k6();
  }
  $this.tc2_1.e3();
  $this.wc2_1 = 0.0;
  $this.yc2_1 = 2.2;
  $this.zc2_1 = 2.6;
  $this.uc2_1 = GameState_RUNNING_getInstance();
  _get_overlay__r3wklb($this).ec5();
  _get_startOverlay__6k8cjh($this).ec5();
  _get_hero__d7k13l($this).v2t();
  $this.jc2_1 = _get_music__e2e0tw($this).l67($this.gc2_1.b16());
  _get_hud__e69vne($this).jc5(1, $this.xc2_1);
}
function update($this, dt) {
  if (dt <= 0.0)
    return Unit_instance;
  _get_hero__d7k13l($this).zc3(dt);
  if (!$this.uc2_1.equals(GameState_RUNNING_getInstance()) || $this.vc2_1)
    return Unit_instance;
  var currentSpeed = speedForElapsed($this, $this.wc2_1);
  _get_background__3vp7tv($this).oc4(dt, currentSpeed);
  $this.wc2_1 = $this.wc2_1 + dt;
  var level = levelForElapsed($this, $this.wc2_1);
  // Inline function 'kotlin.math.max' call
  var b = $this.xc2_1 - $this.wc2_1;
  var secondsLeft = Math.max(0.0, b);
  _get_hud__e69vne($this).jc5(level, secondsLeft);
  if ($this.wc2_1 >= $this.xc2_1) {
    finish($this, GameState_WON_getInstance());
    return Unit_instance;
  }
  $this.yc2_1 = $this.yc2_1 - dt;
  if ($this.yc2_1 <= 0.0) {
    spawnObstacle($this, level);
    $this.zc2_1 = coerceAtLeast(2.75 - level * 0.13, 1.05);
    $this.yc2_1 = $this.zc2_1 + $this.sc2_1.so(0.35, 1.15);
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.tc2_1.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.update.<anonymous>' call
    element.oc4(dt, currentSpeed);
  }
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var this_0 = $this.tc2_1;
    var tmp;
    if (isInterface(this_0, Collection)) {
      tmp = this_0.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = false;
      break $l$block_0;
    }
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.update.<anonymous>' call
      if (element_0.nc4() && element_0.mc4() <= -18.0) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
    }
    tmp$ret$1 = false;
  }
  var lost = tmp$ret$1;
  if (lost) {
    finish($this, GameState_LOST_getInstance());
    return Unit_instance;
  }
  removeAll($this.tc2_1, VikingFootballGame$update$lambda);
}
function perform($this, action) {
  if (!$this.uc2_1.equals(GameState_RUNNING_getInstance()) || $this.vc2_1)
    return Unit_instance;
  _get_hero__d7k13l($this).xc3(action);
  switch (action.k3_1) {
    case 1:
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.minByOrNull' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = $this.tc2_1;
        var destination = ArrayList.i1();
        var tmp0_iterator = this_0.a1();
        while (tmp0_iterator.b1()) {
          var element = tmp0_iterator.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          if (element.bc4_1.equals(ObstacleKind_PLAYER_getInstance()) && element.jc4_1) {
            destination.h(element);
          }
        }
        var iterator = destination.a1();
        if (!iterator.b1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var minElem = iterator.c1();
        if (!iterator.b1()) {
          tmp$ret$3 = minElem;
          break $l$block_0;
        }
        // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
        var minValue = minElem.w6h();
        do {
          var e = iterator.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          var v = e.w6h();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (iterator.b1());
        tmp$ret$3 = minElem;
      }

      var target = tmp$ret$3;
      if (!(target == null)) {
        target.pc4();
        _get_hero__d7k13l($this).yc3(target.w6h(), target.lc4());
      } else {
        _get_hero__d7k13l($this).yc3(1280.0 - 58.0, 594.0 - 96.0);
      }

      break;
    case 2:
      var tmp$ret$12;
      $l$block_2: {
        // Inline function 'kotlin.collections.minByOrNull' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_1 = $this.tc2_1;
        var destination_0 = ArrayList.i1();
        var tmp0_iterator_0 = this_1.a1();
        while (tmp0_iterator_0.b1()) {
          var element_0 = tmp0_iterator_0.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          if (element_0.bc4_1.equals(ObstacleKind_DELIVERY_ROBOT_getInstance()) && element_0.jc4_1) {
            destination_0.h(element_0);
          }
        }
        // Inline function 'kotlin.collections.filterTo' call
        var destination_1 = ArrayList.i1();
        var tmp0_iterator_1 = destination_0.a1();
        while (tmp0_iterator_1.b1()) {
          var element_1 = tmp0_iterator_1.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          var containsLower = 205.0 + 45.0;
          var containsUpper = 205.0 + 230.0;
          var containsArg = element_1.w6h();
          if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
            destination_1.h(element_1);
          }
        }
        var iterator_0 = destination_1.a1();
        if (!iterator_0.b1()) {
          tmp$ret$12 = null;
          break $l$block_2;
        }
        var minElem_0 = iterator_0.c1();
        if (!iterator_0.b1()) {
          tmp$ret$12 = minElem_0;
          break $l$block_2;
        }
        // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
        var minValue_0 = minElem_0.w6h();
        do {
          var e_0 = iterator_0.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          var v_0 = e_0.w6h();
          if (compareTo(minValue_0, v_0) > 0) {
            minElem_0 = e_0;
            minValue_0 = v_0;
          }
        }
         while (iterator_0.b1());
        tmp$ret$12 = minElem_0;
      }

      var tmp1_safe_receiver = tmp$ret$12;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.pc4();
      }

      break;
    case 0:
      var tmp$ret$21;
      $l$block_4: {
        // Inline function 'kotlin.collections.minByOrNull' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_2 = $this.tc2_1;
        var destination_2 = ArrayList.i1();
        var tmp0_iterator_2 = this_2.a1();
        while (tmp0_iterator_2.b1()) {
          var element_2 = tmp0_iterator_2.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          if (element_2.bc4_1.equals(ObstacleKind_FLYING_BALL_getInstance()) && element_2.jc4_1) {
            destination_2.h(element_2);
          }
        }
        // Inline function 'kotlin.collections.filterTo' call
        var destination_3 = ArrayList.i1();
        var tmp0_iterator_3 = destination_2.a1();
        while (tmp0_iterator_3.b1()) {
          var element_3 = tmp0_iterator_3.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          var containsLower_0 = 205.0 - 30.0;
          var containsUpper_0 = 205.0 + 185.0;
          var containsArg_0 = element_3.w6h();
          if (containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false) {
            destination_3.h(element_3);
          }
        }
        var iterator_1 = destination_3.a1();
        if (!iterator_1.b1()) {
          tmp$ret$21 = null;
          break $l$block_4;
        }
        var minElem_1 = iterator_1.c1();
        if (!iterator_1.b1()) {
          tmp$ret$21 = minElem_1;
          break $l$block_4;
        }
        // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
        var minValue_1 = minElem_1.w6h();
        do {
          var e_1 = iterator_1.c1();
          // Inline function 'com.karandashov.viking.football.game.VikingFootballGame.perform.<anonymous>' call
          var v_1 = e_1.w6h();
          if (compareTo(minValue_1, v_1) > 0) {
            minElem_1 = e_1;
            minValue_1 = v_1;
          }
        }
         while (iterator_1.b1());
        tmp$ret$21 = minElem_1;
      }

      var tmp2_safe_receiver = tmp$ret$21;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.pc4();
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function spawnObstacle($this, level) {
  var tmp0_subject = $this.sc2_1.po(100);
  var kind = (0 <= tmp0_subject ? tmp0_subject <= 36 : false) ? ObstacleKind_PLAYER_getInstance() : (37 <= tmp0_subject ? tmp0_subject <= 68 : false) ? ObstacleKind_DELIVERY_ROBOT_getInstance() : ObstacleKind_FLYING_BALL_getInstance();
  var startX = 1280.0 + 90.0 + $this.sc2_1.so(0.0, 220.0);
  // Inline function 'kotlin.collections.plusAssign' call
  var this_0 = $this.tc2_1;
  var element = new ObstacleActor(_get_obstacleLayer__sz6q6n($this), _get_assets__q50yjs($this), kind, startX, level);
  this_0.h(element);
}
function finish($this, nextState) {
  $this.uc2_1 = nextState;
  _get_musicChannel__fsyvwz($this).r5s();
  _get_overlay__r3wklb($this).oc5(nextState.equals(GameState_WON_getInstance()) ? '\u041F\u041E\u0411\u0415\u0414\u0410' : '\u041F\u0420\u041E\u0418\u0413\u0420\u0410\u041B');
}
function levelForElapsed($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value / 20.0;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0) + 1 | 0;
}
function speedForElapsed($this, value) {
  var level = levelForElapsed($this, value);
  return 150.0 + (level - 1 | 0) * 28.0;
}
function enterFullscreenMode($this) {
  unlockMobileAudio();
  requestBrowserFullscreen();
  requestLandscapeOrientation();
}
function setPortraitBlocked($this, isPortrait) {
  $this.vc2_1 = isPortrait;
  if (!($this.pc2_1 == null)) {
    _get_orientationOverlay__a6k3it($this).rc5(isPortrait);
  }
}
function VikingFootballGame$start$lambda(this$0) {
  return function ($this$addUpdater, dt) {
    update(this$0, get_seconds(dt.nj_1));
    return Unit_instance;
  };
}
function VikingFootballGame$enterFullscreenMode$ref($boundThis) {
  var l = function () {
    enterFullscreenMode($boundThis);
    return Unit_instance;
  };
  l.callableName = 'enterFullscreenMode';
  return l;
}
function VikingFootballGame$resetGame$ref($boundThis) {
  var l = function () {
    resetGame($boundThis);
    return Unit_instance;
  };
  l.callableName = 'resetGame';
  return l;
}
function VikingFootballGame$resetGame$ref_0($boundThis) {
  var l = function () {
    resetGame($boundThis);
    return Unit_instance;
  };
  l.callableName = 'resetGame';
  return l;
}
function VikingFootballGame$enterFullscreenMode$ref_0($boundThis) {
  var l = function () {
    enterFullscreenMode($boundThis);
    return Unit_instance;
  };
  l.callableName = 'enterFullscreenMode';
  return l;
}
function VikingFootballGame$enterFullscreenMode$ref_1($boundThis) {
  var l = function () {
    enterFullscreenMode($boundThis);
    return Unit_instance;
  };
  l.callableName = 'enterFullscreenMode';
  return l;
}
function VikingFootballGame$setPortraitBlocked$ref($boundThis) {
  var l = function (p0) {
    setPortraitBlocked($boundThis, p0);
    return Unit_instance;
  };
  l.callableName = 'setPortraitBlocked';
  return l;
}
function VikingFootballGame$setupInput$lambda(this$0) {
  return function (it) {
    perform(this$0, Action_KICK_getInstance());
    return Unit_instance;
  };
}
function VikingFootballGame$setupInput$lambda_0(this$0) {
  return function (it) {
    perform(this$0, Action_JUMP_getInstance());
    return Unit_instance;
  };
}
function VikingFootballGame$setupInput$lambda_1(this$0) {
  return function (it) {
    perform(this$0, Action_EAT_getInstance());
    return Unit_instance;
  };
}
function VikingFootballGame$setupInput$lambda_2(this$0) {
  return function () {
    perform(this$0, Action_JUMP_getInstance());
    return Unit_instance;
  };
}
function VikingFootballGame$setupInput$lambda_3(this$0) {
  return function () {
    perform(this$0, Action_KICK_getInstance());
    return Unit_instance;
  };
}
function VikingFootballGame$setupInput$lambda_4(this$0) {
  return function () {
    perform(this$0, Action_EAT_getInstance());
    return Unit_instance;
  };
}
function VikingFootballGame$update$lambda(obstacle) {
  var shouldRemove = obstacle.kc4_1;
  if (shouldRemove) {
    obstacle.k6();
  }
  return shouldRemove;
}
var Action_JUMP_instance;
var Action_KICK_instance;
var Action_EAT_instance;
var Action_entriesInitialized;
function Action_initEntries() {
  if (Action_entriesInitialized)
    return Unit_instance;
  Action_entriesInitialized = true;
  Action_JUMP_instance = new Action('JUMP', 0);
  Action_KICK_instance = new Action('KICK', 1);
  Action_EAT_instance = new Action('EAT', 2);
}
function Action_JUMP_getInstance() {
  Action_initEntries();
  return Action_JUMP_instance;
}
function Action_KICK_getInstance() {
  Action_initEntries();
  return Action_KICK_instance;
}
function Action_EAT_getInstance() {
  Action_initEntries();
  return Action_EAT_instance;
}
var GameState_READY_instance;
var GameState_RUNNING_instance;
var GameState_LOST_instance;
var GameState_WON_instance;
var GameState_entriesInitialized;
function GameState_initEntries() {
  if (GameState_entriesInitialized)
    return Unit_instance;
  GameState_entriesInitialized = true;
  GameState_READY_instance = new GameState('READY', 0);
  GameState_RUNNING_instance = new GameState('RUNNING', 1);
  GameState_LOST_instance = new GameState('LOST', 2);
  GameState_WON_instance = new GameState('WON', 3);
}
function GameState_READY_getInstance() {
  GameState_initEntries();
  return GameState_READY_instance;
}
function GameState_RUNNING_getInstance() {
  GameState_initEntries();
  return GameState_RUNNING_instance;
}
function GameState_LOST_getInstance() {
  GameState_initEntries();
  return GameState_LOST_instance;
}
function GameState_WON_getInstance() {
  GameState_initEntries();
  return GameState_WON_instance;
}
var ObstacleKind_PLAYER_instance;
var ObstacleKind_DELIVERY_ROBOT_instance;
var ObstacleKind_FLYING_BALL_instance;
var ObstacleKind_entriesInitialized;
function ObstacleKind_initEntries() {
  if (ObstacleKind_entriesInitialized)
    return Unit_instance;
  ObstacleKind_entriesInitialized = true;
  ObstacleKind_PLAYER_instance = new ObstacleKind('PLAYER', 0);
  ObstacleKind_DELIVERY_ROBOT_instance = new ObstacleKind('DELIVERY_ROBOT', 1);
  ObstacleKind_FLYING_BALL_instance = new ObstacleKind('FLYING_BALL', 2);
}
function ObstacleKind_PLAYER_getInstance() {
  ObstacleKind_initEntries();
  return ObstacleKind_PLAYER_instance;
}
function ObstacleKind_DELIVERY_ROBOT_getInstance() {
  ObstacleKind_initEntries();
  return ObstacleKind_DELIVERY_ROBOT_instance;
}
function ObstacleKind_FLYING_BALL_getInstance() {
  ObstacleKind_initEntries();
  return ObstacleKind_FLYING_BALL_instance;
}
function ActionButton$lambda($onPress) {
  return function (it) {
    $onPress();
    return Unit_instance;
  };
}
function ActionButton$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9y_1;
  }, null);
}
function EndOverlay$lambda(this$0) {
  return function (it) {
    this$0.bc5_1();
    return Unit_instance;
  };
}
function EndOverlay$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory_0() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9y_1;
  }, null);
}
function FullscreenButton$lambda($onPress) {
  return function (it) {
    $onPress();
    return Unit_instance;
  };
}
function FullscreenButton$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory_1() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9y_1;
  }, null);
}
function OrientationOverlay$lambda(this$0) {
  return function (it) {
    this$0.pc5_1();
    return Unit_instance;
  };
}
function OrientationOverlay$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory_2() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9y_1;
  }, null);
}
function StartOverlay$lambda(this$0) {
  return function (it) {
    this$0.kc5_1();
    return Unit_instance;
  };
}
function StartOverlay$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function StartOverlay$lambda_1(this$0) {
  return function (it) {
    this$0.lc5_1();
    return Unit_instance;
  };
}
function StartOverlay$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory_3() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9y_1;
  }, null);
}
function down$factory_4() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.w9y_1;
  }, null);
}
function lerp(from, to, ratio) {
  return from + (to - from) * coerceIn(ratio, 0.0, 1.0);
}
function formatSeconds(value) {
  var total = roundToInt(coerceAtLeast(value, 0.0));
  var minutes = total / 60 | 0;
  var seconds = total % 60 | 0;
  return '' + minutes + ':' + padStart(seconds.toString(), 2, _Char___init__impl__6a9atx(48));
}
function scaleToHeight(_this__u8e3s4, targetHeight) {
  _this__u8e3s4.kah(targetHeight / _this__u8e3s4.l2l());
}
function isPortraitOrientation() {
  return window.innerHeight > window.innerWidth;
}
function installOrientationWatcher(onPortraitChanged) {
  var handler = installOrientationWatcher$lambda(onPortraitChanged);
  window.addEventListener('resize', handler);
  window.addEventListener('orientationchange', handler);
  onPortraitChanged(isPortraitOrientation());
}
function requestBrowserFullscreen() {
  (function () {
    try {
      var element = document.documentElement;
      var request = element.requestFullscreen || element.webkitRequestFullscreen || element.msRequestFullscreen;
      if (!request)
        return;
      var result = request.call(element);
      if (result && result.catch)
        result.catch(function () {
        });
    } catch (e) {
    }
  }());
}
function requestLandscapeOrientation() {
  (function () {
    try {
      var orientation = screen.orientation || screen.mozOrientation || screen.msOrientation;
      if (!orientation || !orientation.lock)
        return;
      var result = orientation.lock('landscape');
      if (result && result.catch)
        result.catch(function () {
        });
    } catch (e) {
    }
  }());
}
function unlockMobileAudio() {
  (function () {
    try {
      var context = window.globalAudioContext || window.__vikingFootballAudioContext;
      if (!context) {
        var AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (AudioContextClass) {
          context = new AudioContextClass();
          window.__vikingFootballAudioContext = context;
        }
      }
      if (!context)
        return;
      if (context.state === 'suspended' && context.resume) {
        var resumeResult = context.resume();
        if (resumeResult && resumeResult.catch)
          resumeResult.catch(function () {
          });
      }
      var oscillator = context.createOscillator();
      var gain = context.createGain();
      gain.gain.value = 1.0E-5;
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(0);
      oscillator.stop(context.currentTime + 0.03);
    } catch (e) {
    }
  }());
}
function preloadMusicForMobile(path_0) {
  (function (path) {
    try {
      if (window.__vikingFootballMusicPreload)
        return;
      var audio = new Audio(path);
      audio.preload = 'auto';
      audio.crossOrigin = 'anonymous';
      audio.load();
      window.__vikingFootballMusicPreload = audio;
    } catch (e) {
    }
  }(path));
}
function installOrientationWatcher$lambda($onPortraitChanged) {
  return function (it) {
    $onPortraitChanged(isPortraitOrientation());
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForClass(BallFlight, 'BallFlight');
initMetadataForClass(HeroActor, 'HeroActor');
initMetadataForClass(ObstacleActor, 'ObstacleActor');
initMetadataForCompanion(Companion, VOID, VOID, [0, 3]);
initMetadataForClass(GameAssets, 'GameAssets');
initMetadataForClass(RunningCityBackground, 'RunningCityBackground');
initMetadataForClass(BuildingRow, 'BuildingRow');
initMetadataForClass(Building, 'Building');
initMetadataForClass(VikingFootballGame, 'VikingFootballGame', VOID, VOID, VOID, [0]);
initMetadataForClass(Action, 'Action');
initMetadataForClass(GameState, 'GameState');
initMetadataForClass(ObstacleKind, 'ObstacleKind');
initMetadataForClass(ActionButton, 'ActionButton');
initMetadataForClass(EndOverlay, 'EndOverlay');
initMetadataForClass(FullscreenButton, 'FullscreenButton');
initMetadataForClass(Hud, 'Hud');
initMetadataForClass(OrientationOverlay, 'OrientationOverlay');
initMetadataForClass(StartOverlay, 'StartOverlay');
//endregion
//region block: init
Companion_instance_1 = new Companion();
//endregion
mainWrapper();
